"use client";

import { throttle } from "lodash";
import { useEffect, useState } from "react";
import { PiArrowFatLinesUpFill } from "react-icons/pi";

import { Button } from "../button/button";

export default function NavigationScrollTop() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (document.documentElement.scrollTop > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    }, 50);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      handleScroll.cancel();
    };
  }, []);

  if (!showButton) {
    return null;
  }

  return (
    <Button
      variant="secondary"
      className="fixed bottom-2 right-2 lg:bottom-4 lg:right-4 w-12 h-12 shadow-none p-0 rounded-full hover:scale-105 transition-all duration-200"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll To Top"
    >
      <PiArrowFatLinesUpFill className="w-7 h-7 text-white" />
    </Button>
  );
}
